import React from 'react'

const PackSetOrTag = ({ tagName }) => {
    return <span className={`status ${tagName.toLowerCase()}`}>{tagName}</span>
}

export default PackSetOrTag
